import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellRouter } from '@app/shell/shell-router';
import { SandboxGuard } from './core/guards/sandbox.guard';

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  ShellRouter.childRoutes([
    {
      path: 'profile',
      data: {
        breadcrumb: {
          label: '',
          parsedLabel: '',
          url: '/',
          parsedUrl: '',
          show: true,
          key: 'mainMenuItem',
        },
      },
      loadChildren: () =>
        import('./pages/course-user-profile/course-user-profile.module').then(
          (m) => m.CourseUserProfileModule,
        ),
    },
    {
      path: 'sandbox',
      data: {
        breadcrumb: {
          label: '',
          parsedLabel: '',
          url: '/sandbox',
          show: true,
          key: 'mainMenuItem',
        },
      },
      canActivate: [SandboxGuard],
      loadChildren: () =>
        import('./pages/sandbox/sandbox.module').then((m) => m.SandboxModule),
    },
    {
      path: 'styleguide',
      data: {
        breadcrumb: {
          label: '',
          parsedLabel: '',
          url: '/styleguide',
          show: true,
          key: 'mainMenuItem',
        },
      },
      canActivate: [SandboxGuard],
      loadChildren: () =>
        import('./pages/styleguide/styleguide.module').then(
          (m) => m.StyleguideModule,
        ),
    },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
      path: '**',
      data: {
        breadcrumb: {
          label: '',
          parsedLabel: '',
          url: '/',
          parsedUrl: '',
          show: true,
          key: 'mainMenuItem',
        },
      },
      loadChildren: () =>
        import('./pages/structure-page/structure-page.module').then(
          (m) => m.StructurePageModule,
        ),
    },
  ]),
  // Fallback when no prior route is matched
  //{ path: '', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
